import { InjectionToken } from "@angular/core";


export const LIVECHAT_VERSION = new InjectionToken<string>('This app version');